module.exports = __webpack_public_path__ + "static/media/group_19@3x.a841cf09.png";